var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6899 6.27608C21.0897 6.65709 21.1049 7.29007 20.7239 7.68988L10.2412 18.6899C10.0524 18.8879 9.79081 19 9.51724 19C9.24368 19 8.98205 18.8879 8.79332 18.6899L3.27608 12.9004C2.89507 12.5006 2.91031 11.8676 3.31012 11.4866C3.70993 11.1056 4.34291 11.1208 4.72392 11.5206L9.51724 16.5505L19.2761 6.31012C19.6571 5.91031 20.2901 5.89507 20.6899 6.27608Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.dd2f27a1bcaadf2cd386d212267e3f28.svg";
export { ForwardRef as ReactComponent };